import { render, staticRenderFns } from "./BidsHistory.vue?vue&type=template&id=375cbd8d&scoped=true"
import script from "./BidsHistory.vue?vue&type=script&lang=js"
export * from "./BidsHistory.vue?vue&type=script&lang=js"
import style0 from "./BidsHistory.vue?vue&type=style&index=0&id=375cbd8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375cbd8d",
  null
  
)

export default component.exports